import type { FC } from 'react';
import React from 'react';

import iconSrc from '@wwe-portal/ui/assets/images/store-revamp/green-trophy.webp';

export type GreenTrophyProps = React.ReactComponentElement<'img'>['props'];
export const GreenTrophyIcon: FC<GreenTrophyProps> = (props) => {
  return <img alt="green trophy" src={iconSrc} {...props} />;
};
